import { useState, useEffect } from "react";
import UpdateScoresForm from "./updateScoresForm";

export default function AddGameForm({ API, accessToken, selectedTeamId }) {
  const [games, setGames] = useState([]);
  const [teams, setTeams] = useState([]);
  const [newGame, setNewGame] = useState({
    away_team_id: "",
    date: "",
    location: "",
  });
  const [editingGame, setEditingGame] = useState(null);

  // Fetch all teams
  const fetchTeams = async () => {
    try {
      const res = await fetch(`${API}/teams`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const data = await res.json();
      setTeams(
        Array.isArray(data)
          ? data.filter((t) => t.id !== Number(selectedTeamId))
          : []
      );
    } catch (err) {
      console.error("Failed to fetch teams:", err);
    }
  };

  // Fetch games
  const fetchGames = async () => {
    if (!selectedTeamId) return;
    try {
      const res = await fetch(`${API}/games?team_id=${selectedTeamId}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      const data = await res.json();
      setGames(
        Array.isArray(data)
          ? data.sort((a, b) => new Date(a.date) - new Date(b.date))
          : []
      );
    } catch (err) {
      console.error("Failed to fetch games:", err);
    }
  };

  useEffect(() => {
    fetchTeams();
    fetchGames();
  }, [selectedTeamId]);

  // Handle delete
  const handleDeleteGame = async (gameId) => {
    if (!window.confirm("Delete this game?")) return;

    try {
      const res = await fetch(`${API}/games/${gameId}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${accessToken}` },
      });
      if (!res.ok) throw new Error("Failed to delete game");
      fetchGames();
    } catch (err) {
      console.error(err);
      alert("Error deleting game");
    }
  };

  // Add a new game
  const handleAddGame = async (e) => {
    e.preventDefault();
    if (!newGame.away_team_id || !newGame.date || !newGame.location) return;

    try {
      const res = await fetch(`${API}/games`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          home_team_id: Number(selectedTeamId),
          away_team_id: Number(newGame.away_team_id),
          date: newGame.date,
          location: newGame.location,
        }),
      });
      if (!res.ok) throw new Error("Failed to add game");
      setNewGame({ away_team_id: "", date: "", location: "" });
      fetchGames();
    } catch (err) {
      console.error(err);
      alert("Error adding game");
    }
  };

  if (!selectedTeamId) return null;
console.log("Games:", games);
console.log("EditingGame:", editingGame);

  return (
    <div className="max-w-lg mx-auto mb-10">
      <h2 className="text-lg font-bold mb-2">Add Game</h2>

      {/* Add Game Form */}
      <form
        onSubmit={handleAddGame}
        className="flex flex-col gap-3 bg-gray-100 p-4 rounded shadow"
      >
        <select
          value={newGame.away_team_id}
          onChange={(e) =>
            setNewGame({ ...newGame, away_team_id: e.target.value })
          }
          className="w-full border p-2 rounded"
          required
        >
          <option value="">Select Opponent</option>
          {teams.map((t) => (
            <option key={t.id} value={t.id}>
              {t.name}
            </option>
          ))}
        </select>

        <input
          type="date"
          value={newGame.date}
          onChange={(e) => setNewGame({ ...newGame, date: e.target.value })}
          className="w-full border p-2 rounded"
          required
        />
        <input
          type="text"
          placeholder="Location"
          value={newGame.location}
          onChange={(e) =>
            setNewGame({ ...newGame, location: e.target.value })
          }
          className="w-full border p-2 rounded"
          required
        />

        <div className="flex justify-end">
          <button className="bg-blue-500 px-4 py-2 text-black rounded">
            Add Game
          </button>
        </div>
      </form>

      {/* Existing Games */}
      {games.length > 0 && (
        <div className="mt-6">
          <h3 className="font-semibold mb-2">Scheduled Games:</h3>

          <ul className="space-y-2">
            {games.map((g) => (
              <li key={g.id} className="flex flex-col gap-1 border-b py-1">
                <div className="flex items-center justify-between gap-4">
                  <span className="flex-1 min-w-0 truncate">
                    {g.date} – {g.home_team} vs {g.away_team || "TBD"}{" "}
                    {g.home_score !== null && g.away_score !== null
                      ? `(${g.home_score} – ${g.away_score})`
                      : ""}
                  </span>

                  {/* Buttons */}
                  {editingGame?.id !== g.id && (
                    <div className="flex gap-4 flex-shrink-0">
                      <button
                        type="button"
                        className="bg-yellow-400 text-black px-3 py-1.5 rounded-md text-sm font-medium shadow-sm hover:bg-yellow-500 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                        onClick={() => setEditingGame(g)}
                      >
                        Edit
                      </button>
                      <button
                        type="button"
                        className="bg-red-500 text-black px-3 py-1.5 rounded-md text-sm font-medium shadow-sm hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-300"
                        onClick={() => handleDeleteGame(g.id)}
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </div>

                {/* Inline Update Scores Form */}
                {editingGame?.id === g.id && (
                  <UpdateScoresForm
                    game={g}
                    API={API}
                    accessToken={accessToken}
                    onUpdate={fetchGames}
                    onCancel={() => setEditingGame(null)}
                  />
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
